import * as React from 'react';
import { compose, withProps, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { State } from 'reducers';
import { Navigation } from './Navigation';
import { LayoutOptions } from './LayoutOptions';
import { LanguagePicker } from './LanguagePicker';
import { LogoutLink } from './LogoutLink';
import { QuestionMark } from 'ui/shapes';
import { AboutDialog } from './AboutDialog';
import { launchServerConfig } from 'logic/externalServices/serverConfig';
import { getLanguage } from 'selectors/shellSelectors';
import { withRouter } from 'react-router-dom';

import './TopBar.css';

const serverConfigImgSrc = require('assets/images/m_tsBtnServerSettings.Image.png');

export type OwnProps = {
    allowJoinSession: boolean;
};

export const RawTopBar = ({
    aboutVisible,
    handleClickAbout,
    handleClickServerConfig,
    handleCloseAbout,
    t,
    styles,
}: TranslateProps & RecomposeProps & OemProps) =>
    <div id="top-bar" style={ styles.TopBar }>
        <div style={ styles.title }>
            { t('WEB_CLIENT_TITLE') }
        </div>
        <div/>
        <div>
            <Navigation/>
        </div>
        <div>
            <LayoutOptions/>
        </div>
        <div style={ styles.rightSide }>
            <a
                id="server-config-link"
                href="#"
                onClick={ handleClickServerConfig }
                title={ t('203') }
            >
                <img src={ serverConfigImgSrc } style={ styles.icon }/>
            </a>
            <a
                id="about"
                href="#"
                onClick={ handleClickAbout }
                title={ t('82') }
            >
                <QuestionMark width="1em" height="1em" style={ styles.icon } />
            </a>
            <AboutDialog
                visible={ aboutVisible }
                onClose={ handleCloseAbout }
            />
            <LanguagePicker/>
            <span style={ styles.logout }>
                <LogoutLink/>
            </span>
        </div>
    </div>
;

type StateProps = {
    langCode: string;
};
type RecomposeProps = {
    aboutVisible: boolean;
    handleClickAbout: () => void;
    handleCloseAbout: () => void;
    handleClickServerConfig: () => void;
};
type _RecomposeProps = RecomposeProps & {
    _setAboutVisible: (b: boolean) => void;
};

const mapStateToProps = (state: State) => ({
    langCode: getLanguage(state),
});

export const TopBar = compose<TranslateProps & RecomposeProps & OemProps, OwnProps>(
    translate(),
    skin,
    withRouter, // Router props are not used here... but this fixes a stale navigation issue
    connect<StateProps, void, {}>(mapStateToProps),
    withProps(({ styles }: OemProps) => ({
        styles: {
            ...styles,
            title: {
                paddingLeft: '1em',
            },
            rightSide: {
                textAlign: 'right',
            },
            icon: {
                margin: '.25em .5em',
                fill: styles.Input.color,
                verticalAlign: 'middle',
            },
            logout: {
                margin: '0 20px',
            },
        },
    })),
    withState('aboutVisible', '_setAboutVisible', false),
    withHandlers<OwnProps & StateProps & _RecomposeProps, Partial<RecomposeProps>>({
        handleClickAbout: ({ _setAboutVisible }) => () => {
            _setAboutVisible(true);
        },
        handleCloseAbout: ({ _setAboutVisible }) => () => {
            _setAboutVisible(false);
        },
        handleClickServerConfig: ({ allowJoinSession, langCode }) => () => {
            launchServerConfig(allowJoinSession, langCode);
        },
    }),
)(RawTopBar);



// WEBPACK FOOTER //
// ./src/ui/main/header/TopBar.tsx